import * as React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';
import Container from '@mui/material/Container';

import ResponsiveAppBar from './AppBar';
import Content from './Content';
import ResponseFooter from './Footer';

//import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <ResponsiveAppBar />
        <main>
            <Container maxWidth="md">
                <Content />
            </Container>
        </main>
        <footer>
            <ResponseFooter />
        </footer>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
